import { Component, OnInit } from '@angular/core';
import { LeadSellerGroupService } from '../../services/lead-seller-group/lead-seller-group.service';
import { Observable } from 'rxjs';
import { selectAllMembersSelected, selectDealerGroupCount } from '../../services/lead-seller-group/reducer';
import { TranslocoDirective } from '@jsverse/transloco';
import { TrackDirective } from 'remarketing-ui-components-lib';
import {
  DealerGroupSectionComponent
} from '../dealer-group-section/dealer-group-section.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-dealer-group-popover',
    templateUrl: './dealer-group-popover.component.html',
    styleUrls: ['./dealer-group-popover.component.scss'],
    imports: [TranslocoDirective, TrackDirective, DealerGroupSectionComponent, CommonModule]
})
export class DealerGroupPopoverComponent implements OnInit {
  open = false;
  dealerGroups$ = this.leadSellerGroupService.state$;
  readonly allSelected$: Observable<boolean> = this.leadSellerGroupService.select(selectAllMembersSelected);
  dealershipGroupCount = 0;

  constructor(private readonly leadSellerGroupService: LeadSellerGroupService) {}

  ngOnInit() {
    this.leadSellerGroupService.search('');
    this.leadSellerGroupService.select(selectDealerGroupCount).subscribe(groupCount => {
      this.dealershipGroupCount = groupCount;
    });
  }

  toggleAll() {
    this.leadSellerGroupService.toggleAll();
  }

  search(e) {
    this.leadSellerGroupService.search(e.target.value.toLowerCase().trim());
  }

  toggleGroup(groupUuid: string) {
    this.leadSellerGroupService.toggleGroup(groupUuid);
  }

  toggleMember(uuid: string) {
    this.leadSellerGroupService.toggleMember(uuid);
  }

  get isSellerAssociatedToMultipleLeadSellerGroup() {
    return this.dealershipGroupCount && this.dealershipGroupCount > 1;
  }
}
